<script>
    import moment from 'moment';
    import {SW_DATE_FORMAT} from '../../common/constants.js';

    export let row = {};
    export let key = 'created_date';
    export let format = SW_DATE_FORMAT;
    export let all = 'false';
    export let defaultValue = ''

    let rawDate;
    let momentDate;
    let formattedDate = defaultValue;

    $: renderDate(row);
    
    function renderDate(row){
        rawDate = row[key];
        if(rawDate){
            momentDate = moment.parseZone(rawDate);
            formattedDate = momentDate.format(format);
        }
    }
  
</script>

<style>
    
</style>

{#if all == 'true' && row.start_time && !row.expired && !row.end_time}
    <i class="fa fa-arrow-circle-right" id={row.id} style="color: #32A532;margin-right:3px;"></i>{formattedDate}
{:else}
    {formattedDate}
{/if}
